import React from 'react'
import R from 'ramda'
import {FormattedMessage} from 'react-intl'
import {connect} from 'react-redux'

import Features from './Features'
import Options from './Options'

import onChange from '../actions/searchFormChange'
import toggleMoreOptions from '../actions/toggleMoreOptions'

const SearchForm = (props) => {
  const featuresProps = R.pick(['currency', 'query', 'options', 'areaUnit', 'onChange'], props)
  const optionsProps =  R.pick(['query', 'show', 'onToggleMoreOptions', 'onChange'], props)
  return <div style={{display: 'flex', flexDirection: 'column'}}>
    <label className="title-category">
      <FormattedMessage id="Features" defaultMessage="Features"/>
    </label>
    <Features  {...featuresProps}/>
    <Options {...optionsProps}/>
  </div>
}

SearchForm.propTypes = {
  options: React.PropTypes.object.isRequired,
  query: React.PropTypes.object.isRequired,
  currency: React.PropTypes.string.isRequired,
  areaUnit: React.PropTypes.string.isRequired,
  show: React.PropTypes.shape({
    moreOptions: React.PropTypes.bool.isRequired
  }),
  
  onChange: React.PropTypes.func.isRequired,
  onToggleMoreOptions: React.PropTypes.func.isRequired,
}

const mapStateToProps = (state, ownProps) => {
  const props = [
    'areaUnit',
    'currency',
    'onChange',
    'onToggleMoreOptions',
    'options',
    'show',
  ] 
  return R.merge(R.pick(props, state), {query:ownProps.query})
}

const mapDispatchToProps = (dispatch) => {
  return {
    onChange: field => value => dispatch(onChange(field, value)),
    onToggleMoreOptions: _ => dispatch(toggleMoreOptions()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SearchForm)



/** WEBPACK FOOTER **
 ** ./app/components/SearchForm.jsx
 **/